export enum DataHooksQueryKey {
    Airlines = "airlines",
    DeliveryEndpoints = "delivery-endpoints",
    Dubbings = "dubbings",
    DynamicSubtitles = "dynamic-subtitles",
    EmbeddedSubtitles = "embedded-subtitles",
    EncodeSpecifications = "encode-specifications",
    Languages = "languages",
    NonTrailerVersionTypes = "non-trailer-version-types",
    OrderAirlines = "order-airlines",
    Resolutions = "resolutions",
    Systems = "systems",
    TrailerVersionTypes = "trailer-version-types"
}
